import React from "react";
import { auth, facebookporvider } from "../../../config/firebase";
import { signInWithPopup } from "firebase/auth";
import { FaFacebookF } from "react-icons/fa";

export default function FacebookLogin() {
  const signInWithFacebook = async () => {
    console.log("Facebook login");
    signInWithPopup(auth, facebookporvider)
      .then(async (result) => {
        console.log(result);
      })
      .catch((error) => {
        console.error("Authentication error:", error.code, error.message);
      });
  };

  return (
    <div className="login-buttons py-2">
      <button
        className="login-provider-button facebook-btn"
        onClick={signInWithFacebook}
      >
        <FaFacebookF className="icon" />
        <span>Continue with Facebook</span>
      </button>
    </div>
  );
}
